var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ERW---Package-Alerts",
    transform: "translate(-432.000000, -367.000000)",
    fill: "#3f6d6e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(59.000000, 351.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(373.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.875,0.833333333 L12,0.833333333 L12,0.416666667 C12,0.186666667 11.832,0 11.625,0 C11.418,0 11.25,0.186666667 11.25,0.416666667 L11.25,0.833333333 L3.75,0.833333333 L3.75,0.416666667 C3.75,0.186666667 3.582,0 3.375,0 C3.168,0 3,0.186666667 3,0.416666667 L3,0.833333333 L1.125,0.833333333 C0.50475,0.833333333 0,1.39416667 0,2.08333333 L0,13.75 C0,14.4391667 0.50475,15 1.125,15 L13.875,15 C14.49525,15 15,14.4391667 15,13.75 L15,2.08333333 C15,1.39416667 14.49525,0.833333333 13.875,0.833333333 Z M1.125,1.5 L3,1.5 L3,2.625 C3,2.832 3.168,3 3.375,3 C3.582,3 3.75,2.832 3.75,2.625 L3.75,1.5 L11.25,1.5 L11.25,2.625 C11.25,2.832 11.418,3 11.625,3 C11.832,3 12,2.832 12,2.625 L12,1.5 L13.875,1.5 C14.082,1.5 14.25,1.668 14.25,1.875 L14.25,3.85903719 L0.75,3.85903719 L0.75,1.875 C0.75,1.668 0.918,1.5 1.125,1.5 Z M13.875,14.25 L1.125,14.25 C0.918,14.25 0.75,14.0667273 0.75,13.8409091 L0.75,4.85903823 L14.25,4.85903823 L14.25,13.8409091 C14.25,14.0667273 14.082,14.25 13.875,14.25 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(2.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-7",
    cx: 0.576774314,
    cy: 3.24453598,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-12",
    cx: 0.571153846,
    cy: 6.103125,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    cx: 2.85576923,
    cy: 0.590625,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-8",
    cx: 2.8613897,
    cy: 3.24453598,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-13",
    cx: 2.85576923,
    cy: 6.103125,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-4",
    cx: 5.14038462,
    cy: 0.590625,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-9",
    cx: 5.14600508,
    cy: 3.24453598,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-14",
    cx: 5.14038462,
    cy: 6.103125,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-5",
    cx: 7.425,
    cy: 0.590625,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-10",
    cx: 7.43062047,
    cy: 3.24453598,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-15",
    cx: 7.425,
    cy: 6.103125,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-6",
    cx: 9.70961538,
    cy: 0.590625,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-11",
    cx: 9.71523585,
    cy: 3.24453598,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-16",
    cx: 9.70961538,
    cy: 6.103125,
    rx: 1,
    ry: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar2);
export default __webpack_public_path__ + "static/media/Calendar2.72bb5d83c13b93b0841475c7fc51cc47.svg";
export { ForwardRef as ReactComponent };